import React, { useState, useEffect } from 'react';
import ReactGA from 'react-ga4';
import { useDispatch, useSelector } from 'react-redux';
// import { GoogleApiWrapper } from 'google-maps-react';

import Header from './Header';
import Footer from './Footer';
import { getUserDetails } from '../store/slices/user';
import ScrollToTop from '../components/common/ScrollToTop';

// const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_CODE);

const GuestLayout = ({title, children}) => {

	const dispatch = useDispatch();
	const [isHomePage, setHomePage] = useState(false);
	const { token } = useSelector((state) => state.auth);

	useEffect(() => {
		if(token) {
			dispatch(getUserDetails())
		}
	}, [dispatch, token]);

	useEffect(() => {
		if(window.location.pathname === '/') {
			setHomePage(true)
		} else {
			setHomePage(false)
		}
	}, [window.location.pathname]);

	useEffect(() => {
        ReactGA.send({ hitType: 'pageview', page: window.location.pathname + window.location.search });
    }, []);

	return (
		<div id="main">
			<Header 
			//	bg={isHomePage ? 'transparent' : 'color'}
				bg='color'
				isHomePage={false} 
			/>  

			<div id="wrapper">
            	<div className="content">
					{children}
				</div>
			</div>
			
			{window.location.pathname !== '/search' &&
				<Footer />
			}

            <ScrollToTop />
	    </div>		
	)
}

export default GuestLayout;
// export default GoogleApiWrapper({
//     apiKey: GOOGLE_MAPS_API_KEY
// })(GuestLayout);